<template>
    <div class="vote_info">
        <div class="info_list">
            <el-card>
                <el-form inline size="small" :model="queryFiles" label-width="80px">
                    <el-form-item label="作品编号">
                        <el-input clearable v-model="queryFiles.worksNumber" placeholder="输入序号"></el-input>
                    </el-form-item>
                    <el-form-item label="作品类别">
                        <el-select v-model="queryFiles.voteType" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in voteTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作品组别">
                        <el-select v-model="queryFiles.voteGrouping" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in voteGroupings"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                      <el-form-item label="身份">
                        <el-select v-model="queryFiles.part" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in parts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作者名称">
                        <el-input clearable v-model="queryFiles.authorName" placeholder="输入作者名称"></el-input>
                    </el-form-item>
                    <el-form-item label="作者单位">
                        <el-input clearable v-model="queryFiles.authorUnit" placeholder="输入作者单位"></el-input>
                    </el-form-item>
                    <el-form-item label="作者类别">
                        <el-select v-model="queryFiles.authorType" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in authorTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报名时间">
                        <el-date-picker
                            v-model="dateValue"
                            @change="dateChange"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="作品状态">
                        <el-select v-model="queryFiles.worksType" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in worksTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item> -->
                </el-form>
                <el-button style="margin-left: 80px" type="primary" @click="getVoteList">查询</el-button>
                <el-button style="margin-left: 20px" type="danger" @click="resetBtn">重置</el-button>
                <el-button style="margin-left:20px" type="primary" @click="downloadBtnOne">下载名称</el-button>
                <el-button style="margin-left:20px" type="primary" @click="downloadBtnTwo">下载全称</el-button>
                <el-button style="margin-left: 20px" type="primary" @click="btn_pass">淘汰的作品</el-button>
            </el-card>
            <el-card>
                <el-table :data="voteList"
                    :header-cell-style="getRowClass"
                    border
                    ref="multipleTable"
                    style="width: 100%; flex: auto;" tooltip-effect="light"
                    @selection-change="handleSelectionChange"
                    >
                    <el-table-column type="selection" width="45" align="center"></el-table-column>
                    <el-table-column align="center" width="60" label="作品编号" prop="works_number" fixed></el-table-column>
                    <el-table-column label="作品" align="center">
                        <template slot-scope="{row}">
                            <!-- <video 
                            v-if="row.vote_type===2 || row.vote_type===3"
                            :src="row.img_url" 
                            @click="openImgVideo(row)" 
                            style="width: 65px; height: 65px;cursor: pointer;">
                            </video> -->
                            <img v-if="row.vote_type===2 || row.vote_type===3" :src="row.cover_img"  @click="openImgVideo(row)" 
                            style="width: 65px; height: 65px;cursor: pointer;"/>
                            
                            <el-image v-else preview-teleported
                            :src="row.img_url"
                            :preview-src-list="[row.img_url]"
                            :z-index="9999"
                            style="width: 65px; height: 65px;"
                            ></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(item,idx) in VoteInfoListField" :key="idx" v-bind="item"></el-table-column>
                    <el-table-column label="操作" fixed="right" align="center" width="300">
                        <template slot-scope="{ row }">
                            <el-button
                                size="small"
                                type="primary"
                                @click="editVoteNum(row)"
                                >票数</el-button>

                            <el-button
                                size="small"
                                type="primary"
                                @click="editVoteInfo(row)"
                            >修改</el-button>

                            <el-button
                                size="small"
                                type="danger"
                                @click="passVote(row.id,1)"
                            >淘汰</el-button>

                            <!-- <el-button v-if="row.works_type === 0"
                                size="small"
                                type="success"
                                @click="passVote(row.id,2)"
                            >晋级</el-button> -->

                            <el-dropdown trigger="click" style="margin-left: 10px;">
                            <el-button  size="small" type="success">授权</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="viewAuthorizeImg(row)">查看</el-dropdown-item>
                                <el-dropdown-item @click.native="downAuthorizeImg(row)">下载</el-dropdown-item>
                            </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row>
                    <el-pagination
                        style="display: flex;justify-content: center;margin-top: 20px"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[20, 30, 40, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalElements">
                    </el-pagination>
                </el-row>
            </el-card>
        </div>

        <!--修改信息弹出框-->
        <a-modal title="编辑" v-model="editVisible">
            <el-form :model="supplyEditModel" inline size="small" label-width="75px">
                <el-row>
                    <el-form-item label="作者名">
                        <el-input v-model="supplyEditModel.authorName" placeholder="请输入内容" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="作者电话">
                        <el-input v-model="supplyEditModel.phone" placeholder="请输入内容" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="作品名称">
                        <el-input v-model="supplyEditModel.worksName" placeholder="请输入内容" clearable></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                <el-form-item label="作品介绍">
                    <el-input 
                    style="width: 460px;"
                    type="textarea"
                    :rows="4" 
                    v-model="supplyEditModel.introduce" 
                    placeholder="请输入内容" clearable></el-input>
                </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="作者类别" prop="authorType">
                        <el-select v-model="supplyEditModel.authorType" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in authorType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作品组别" prop="voteGrouping">
                        <el-select v-model="supplyEditModel.voteGrouping" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in voteGrouping"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button v-bind="bindBtnStyle" @click="editVisible = false">取消</el-button>
                <el-button v-bind="bindBtnStyle" @click="fn_edit_finish">确定</el-button>
            </span>
        </a-modal>

        <!--修改票数-->
        <a-modal v-model="editNumVisibile" title="修改票数" class="ant-body">
            <el-form>
                <el-form-item label="票数">
                    <el-input 
                    v-model="supplyEditModel.voteNumber" 
                    placeholder="请输入票数" 
                    clearable
                    style="width: 260px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button v-bind="bindBtnStyle" @click="editNumVisibile = false">取消</el-button>
                <el-button v-bind="bindBtnStyle" @click="fn_edit_finish">确定</el-button>
            </span>
        </a-modal>

          <!--视频-->
        <el-dialog :visible.sync="viewVideoDialog" :append-to-body="true" 
        width="70%" class="view_style_video"
        center @close="viewDialogClose">
            <video-player class="video-player vjs-custom-skin carousel-video"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
            </video-player> 
        </el-dialog>

        <!--查看授权书-->
        <el-dialog 
            title="授权书" 
            class="dialog_style" 
            :visible.sync="showAuthorizeImg" 
            :append-to-body="true"
             @close="authorizeImgCancel">
             <img :src="authorizeImg" style="width:100%;" />
            <!-- <el-image
                style="height: 100%;max-height: 110vh;  width:100%;"
                :src="authorizeImg"
                fit="contain"
                :preview-teleported="true"
            /> -->
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import JSZip from "jszip"
import { saveAs } from 'file-saver';

export default{
    data(){
        return{
            playerOptions: {
            //播放速度
            playbackRates: [0.5, 1.0, 1.5, 2.0],
            //如果true,浏览器准备好时开始回放。
            autoplay: false,
            // 默认情况下将会消除任何音频。
            muted: false,
            // 导致视频一结束就重新开始。
            loop: false,
            // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            preload: 'auto',
            language: 'zh-CN',
            // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            aspectRatio: '16:9',
            // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            fluid: true,
            sources: [{
                //类型
                type: "video/mp4",
                //url地址
                src: ''
            }],
            //你的封面地址
            poster: '',
            //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            //全屏按钮
            fullscreenToggle: true
            }
            },
            showAuthorizeImg:false,
            authorizeImg:'',
            bindBtnStyle: {
                type: "primary",
                size: "small",
                round: true
            },
            supplyEditModel: {
                voteNumber:"",//票数
                    voteGrouping: "", //作品组别1小学生 2中高学生 3大学生 4教师
                    worksName: "", //作品名称
                    authorName: "", //作者名称
                    phone: "", //电话号码
                    introduce: "", //作品介绍
                    authorType: "" //作者类别 1个人 2团队
            },
            voteGrouping:[//作品组别 
                {  
                    value: 1,
                    label: "中小学",
                },{
                    value:2,
                    label: "高校",
                }
            ],
            part:[{
                value: 1,
                label: "学生",
            },{
                value: 2,
                label: "教师",
            }],
            authorType:[{  //作者类别
                    value: 1,
                    label: "个人",
                },{
                    value: 2,
                    label: "团队",
                }
            ],
            editVisible: false,
            editNumVisibile:false,
            viewVideoDialog:false,
            dateValue:"",
            queryFiles: {
                worksNumber: "", //作品序号
                voteType: "", //详情类型 1图片 2视频
                voteGrouping: "", //作品组别1中小学 2高校
                part:"",//身份
                authorName: "", //作者姓名
                authorUnit: "", //作者单位
                authorType: "", //作者类别 1个人 2团队 3单位
                startDate:"",
                endDate:"",
                //worksType:"" //作品状态 0初始 1淘汰 2晋级
            },
            //详情类型
            voteTypes: [{
                    id: "1",
                    name: "图片"
                },{
                    id: "2",
                    name: "视频"
                },{
                    id:"3",
                    name:"AI视频"
                }
            ],
                //作品组别 
            voteGroupings:[{
                id: "1",
                name: "中小学",
                },{
                id: "2",
                name: "高校",
                }
            ],
                //身份 
            parts:[{
                id: "1",
                name: "学生",
                },{
                id: "2",
                name: "教师",
                }
            ],
            //作者类别
            authorTypes:[{
                id: "1",
                name: "个人",
                },{
                id: "2",
                name: "团队",
                }
            ],
            //作品状态
            worksTypes:[{
                id: "0",
                name: "初始",
                },
                {
                id: "2",
                name: "晋级",
                }
            ],
            //表格列表列头
            VoteInfoListField: [
                {
                    label: "报名时间",
                    prop: "enroll_date",
                    width:"160"
                },{
                    label: "排名",
                    prop: "ranking"
                },{
                    label: "当前票数",
                    prop: "vote_number",
                },{
                    label: "作品类型",
                    prop: "vote_type",
                    formatter(row, column,val) {
                        return val===1 ?"图片":val==2?"视频":"AI视频";
                    }
                },{
                    label: "作品组别",
                    prop: "vote_grouping",
                    formatter(row, column,val) {
                        return val===1 ?"中小学":"高校";
                    }
                },{
                    label: "身份",
                    prop: "part",
                    formatter(row, column,val) {
                        return val===1 ?"学生":"教师";
                    }
                },{
                    label: "作品名称",
                    prop: "works_name",
                    width:"150"
                },{
                    label: "作者",
                    prop: "author_name",
                },{
                    label: "单位",
                    prop: "author_unit",
                },{
                    label: "电话",
                    prop: "phone",
                    width:"120"
                },{
                    label: "作品简介",
                    prop: "introduce",
                },{
                    label: "作者类别",
                    prop: "author_type",
                    formatter(row, column,val) {
                        return val ===1 ? "个人" : val === 2 ? "团队" : "单位";
                    }
                },{
                    label: "状态",
                    prop: "works_type",
                    formatter(row, column,val) {
                        return val === 2? "晋级" :  "初始" ;
                    }
                },
            ].map(item => ({
                ...item,
                align: "center",
                "header-align": "center",
                "show-overflow-tooltip": true
            })),
            pageNum: 1,
            pageSize: 20,
            totalElements: 0,//数据总数
            voteList:[],
            imgUrl:'',
            voteType:'',
            worksType:'',
            multipleSelection:[],
        }
    },
    created() {
        this.$nextTick(() => {
            this.getVoteList();
        });
    },
    methods:{
        dateChange(e){
            if(e==null){
                this.dateValue=[]
                return
            }
            this.dateValue = e
            this.queryFiles.startDate = moment(this.dateValue[0]).format('YYYY-MM-DD HH:mm:ss')
            this.queryFiles.endDate = moment(this.dateValue[1]).format('YYYY-MM-DD HH:mm:ss')
            console.log('开始时间：'+this.queryFiles.startDate,'结束时间：'+this.queryFiles.endDate)
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        getFileOss(url){
            let startIndex = url.lastIndexOf("/");
            if (startIndex !== -1) {
                return url.slice(startIndex + 1).toLowerCase();
            } else {
                return "";
            }
        },
        //下载名称
        downloadBtnOne(){
           const selectDate=this.multipleSelection;
           if (selectDate.length == 1) { //单张下载
                //console.log('sss'+selectDate[0].img_url)
                const imageUrl = selectDate[0].img_url;
                let suffix=this.getFileOss(imageUrl);
                //console.log('sss11:'+suffix)
                const xhr = new XMLHttpRequest();
                xhr.open("GET", imageUrl, true);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        const url = window.URL.createObjectURL(xhr.response);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", suffix);
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        console.error("图片下载失败");
                    }
                };
                xhr.send();
           }else{  //批量下载
                this.createAndDownloadImageZipName(selectDate);
           }
        },
        createAndDownloadImageZipName(selectDate) {
            const zip = new JSZip();
            console.log('数量1'+selectDate.length);
            for (let i = 0; i < selectDate.length; i++) {
                // 获取图片资源
                fetch(selectDate[i].img_url).then(response => response.blob()).then(blob => {
                    let suffix=this.getFileOss(selectDate[i].img_url)
                    // 将Blob添加到ZIP包中，这里假设图片名为'image'+i+'.jpg'
                    //zip.file(`${selectDate[i].works_name}_${i}.${suffix}`, blob);
                    zip.file(`${suffix}`, blob);
                    // 在所有图片都处理完之后生成ZIP
                    if (i === selectDate.length - 1) {
                        zip.generateAsync({ type: 'blob' }).then(content => {
                            // 下载ZIP文件
                            saveAs(content, 'download.zip');
                        });
                    }
                });
                
            }
        }, 
        //下载全称
        downloadBtnTwo(){
           const selectDate=this.multipleSelection;
           if (selectDate.length == 1) { //单张下载
                //console.log('sss'+selectDate[0].img_url)
                const imageUrl = selectDate[0].img_url;
                let suffix=this.getFilefType(imageUrl);
                const xhr = new XMLHttpRequest();
                xhr.open("GET", imageUrl, true);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        const url = window.URL.createObjectURL(xhr.response);
                        const link = document.createElement("a");
                        link.href = url;
                        //link.setAttribute("download", "image.png");
                        link.setAttribute("download", (selectDate[0].author_name+'_'+selectDate[0].works_name+'_'+selectDate[0].author_unit+'_'+selectDate[0].vote_number)+'.'+suffix);
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        console.error("图片下载失败");
                    }
                };
                xhr.send();
           }else{  //批量下载
                // const imageUrls = []; // 替换为实际的图片URL数组
                // const filenames = []; // 对应的文件名数组
                // selectDate.forEach(ii => {
                //     imageUrls.push(ii.img_url)
                //      let suffix=this.getFilefType(ii.img_url)
                //      filenames.push((ii.works_name || ii.works_number) + '.'+suffix)
                // })
                //this.createAndDownloadImageZip(imageUrls, filenames);
                this.createAndDownloadImageZip(selectDate);
           }
        },
        createAndDownloadImageZip(selectDate) {
            const zip = new JSZip();
            //console.log('数量'+selectDate.length);
            for (let i = 0; i < selectDate.length; i++) {
                // 获取图片资源
                fetch(selectDate[i].img_url).then(response => response.blob()).then(blob => {
                    let suffix=this.getFilefType(selectDate[i].img_url)
                    // 将Blob添加到ZIP包中，这里假设图片名为'image'+i+'.jpg'
                    zip.file(`${selectDate[i].author_name+'_'+selectDate[i].works_name+'_'+selectDate[i].author_unit+'_'+selectDate[i].vote_number}.${suffix}`, blob);
                    // 在所有图片都处理完之后生成ZIP
                    if (i === selectDate.length - 1) {
                        zip.generateAsync({ type: 'blob' }).then(content => {
                            // 下载ZIP文件
                            saveAs(content, 'download.zip');
                        });
                    }
                });
                
            }
        }, 
        // 获取文件后缀名
        getFilefType(url) {
            let startIndex = url.lastIndexOf(".");
            if (startIndex !== -1) {
                return url.slice(startIndex + 1).toLowerCase();
            } else {
                return "";
            }
        },
        btn_pass() {
            this.$router.push("/eliminateList");
        },
            //头部样式
        getRowClass({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
            } else {
                return "";
            }   
        },
        //查询
        getVoteList(){
            this.postAxios("/secureVote/selectAllSecureVote", {
                pageNum: this.pageNum,
                pageSize:this.pageSize,
                parameterMap:{
                    worksType:"0",
                    ...this.queryFiles
                }
            }).then((res) => {
                if (res.success) {
                    //this.voteList = res.content.filter(worksType=>worksType.works_type!==1);
                    this.voteList = res.content;
                    this.totalElements = res.totalCount
                } else {
                    this.$message.error(res.message);
                    this.$router.push("/");
                }
            });
        },
        //分页
        handleCurrentChange: function (currentPage) {
            this.pageNum = currentPage;
            this.getVoteList();
        },
        handleSizeChange: function (size) {
            this.pageSize = size;
            this.getVoteList();
        },
        resetBtn() {
            this.pageNum = 1;
            this.pageSize = 20;
            this.dateValue="";
            this.queryFiles={};
            this.getVoteList();
        },
        //点击放大图片视频
        openImgVideo(row){
            if(row.vote_type===2 || row.vote_type===3){
                this.playerOptions.poster = row.cover_img;
                this.playerOptions.sources[0].src = row.img_url;
                this.viewVideoDialog=true;
            }
        },
        viewDialogClose(){
            if(this.$refs.videoPlayer){
                this.$refs.videoPlayer.player.pause();
            }
            this.viewVideoDialog=false;
        },
        //修改票数
        editVoteNum(row){
            this.editNumVisibile=true;
            this.supplyEditModel.id=row.id;
            this.supplyEditModel.voteNumber=row.vote_number;
        },
        //修改信息
        editVoteInfo(row){
            this.editVisible=true;
            //this.$set(this, "supplyEditModel", row);
            this.supplyEditModel.id=row.id;
            this.supplyEditModel.voteGrouping=row.vote_grouping;
            this.supplyEditModel.worksName=row.works_name;
            this.supplyEditModel.authorName=row.author_name;
            this.supplyEditModel.phone=row.phone;
            this.supplyEditModel.introduce=row.introduce;
            this.supplyEditModel.authorType=row.author_type
        },
        fn_edit_finish(){
            this.postAxios("secureVote/updAllDataById",{
                ...this.supplyEditModel
            }).then(res=>{
                if (res.success == true) {
                    this.$message.success("修改成功！");
                    this.editVisible=false;
                    this.editNumVisibile=false;
                    this.getVoteList();
                }else if (res.success == false) {
                    this.$message.error(res.message);
                } else if (!res.success && res.statusCode == "401") {
                    this.$message.error(res.message);
                    this.$router.push("/");
                }
            })
        },
        //淘汰、晋级
        passVote(id,type){
            this.postAxios("/secureVote/updSecureVoteById", {
                id: id,
                worksType:type
            }).then(res => {
                if (res.success == true) {
                    this.getVoteList();
                    if(type==1){
                        this.$message.success("淘汰成功！");
                    }else{
                        this.$message.success("晋级成功！");
                    }
                } else if (res.success == false) {
                    this.$message.error(res.message);
                } else if (!res.success && res.statusCode == "401") {
                    this.$message.error(res.message);
                    this.$router.push("/");
                }
            });
        },
        viewAuthorizeImg(row){
            this.authorizeImg=row.authorize_img;
            this.showAuthorizeImg=true;
        },
        authorizeImgCancel(){
            this.showAuthorizeImg=false;
        },
        downAuthorizeImg(row){
            //console.log('数据1'+row)
            const imageUrl = row.authorize_img;
            let suffix=this.getFilefType(imageUrl);
            const xhr = new XMLHttpRequest();
            xhr.open("GET", imageUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (xhr.status === 200) {
                    const url = window.URL.createObjectURL(xhr.response);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",'授权书.'+suffix);
                    document.body.appendChild(link);
                    link.click();
                } else {
                    console.error("图片下载失败");
                }
            };
            xhr.send();
            
        }
    }
}
</script>

<style scoped lang="less">
.vote_info{
    width: 100%;
    height: 100%;
    .info_list{
        width: 95%;
        height: 100%;
        margin: 20px auto;
        .el-card {
        width: 100%;
        height: auto;
        margin-top: 15px;
        }
    }
}
/deep/ .el-table .cell{
    padding: 0;
}
/deep/ .el-table .cell, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
    padding: 0;
}
/deep/ .el-table--border th:first-child .cell, .el-table--border td:first-child .cell{
    padding: 0;
}
/deep/ .ant-modal-content {
  width: 600px;
}
.ant-body /deep/ .ant-modal-content{
    width: 360px;
}

/deep/ .img-style{
     width: 100%;
     height: 100vh;
     margin: 0;
}
.carousel-video{
    height: auto;
    width: 100%;
    margin: 0 auto;
}
.view_style_video{
     /deep/.el-dialog {
      margin-top: 5vh !important;
     }
}
.dialog_style{
     /deep/.el-dialog {
      margin-top: 5vh !important;
      width: -webkit-calc(~'45vw') !important;
      width: -moz-calc(~'45vw') !important;
      width: calc(~'45vw') !important;
      height: -webkit-calc(~'90vh') !important;
      height: -moz-calc(~'90vh') !important;
      height: calc(~'90vh') !important;
      .el-dialog__body {
        box-sizing: border-box;
        padding: 5px 20px 20px;
        width: -webkit-calc(~'45vw') !important;
        width: -moz-calc(~'45vw') !important;
        width: calc(~'45vw') !important;
        height: -webkit-calc(~'90vh - 100px') !important;
        height: -moz-calc(~'90vh - 100px') !important;
        height: calc(~'90vh - 100px') !important;
        img {
          width: 100% !important;
          height: 100% !important;
          object-fit: scale-down !important;
        }
      }
    }
}
/deep/ .el-icon-circle-close{
    color: #fff;
}

</style>